import { useService } from '../utils';
export const useLoadRestrictedPrincipals = loadFn => {
  const service = useService(loadFn);
  return {
    ...service,
    loadRestrictedPrincipals: service.fetch
  };
};